var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_981_1913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.34123 7.90355C0.340855 9.24786 0.694855 10.5605 1.36798 11.7174L0.276855 15.6704L4.35386 14.6097C5.4815 15.2188 6.74494 15.538 8.02886 15.5381H8.03223C12.2707 15.5381 15.7209 12.1159 15.7227 7.90956C15.7235 5.8713 14.9242 3.95465 13.4721 2.51266C12.0202 1.0708 10.0893 0.276321 8.03192 0.275391C3.79298 0.275391 0.343043 3.69741 0.341293 7.90355",
    fill: "url(#paint0_linear_981_1913)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.066875 7.90177C0.0664375 9.29445 0.433125 10.654 1.13025 11.8524L0 15.9471L4.22319 14.8484C5.38681 15.4779 6.69694 15.8098 8.03006 15.8103H8.0335C12.424 15.8103 15.9981 12.265 16 7.90809C16.0008 5.79659 15.1727 3.81104 13.6687 2.3174C12.1646 0.823938 10.1646 0.000868217 8.0335 0C3.64225 0 0.068625 3.54481 0.066875 7.90177ZM2.58194 11.646L2.42425 11.3976C1.76137 10.3518 1.4115 9.14326 1.412 7.90226C1.41337 4.28087 4.38363 1.33457 8.036 1.33457C9.80475 1.33532 11.467 2.01947 12.7172 3.26078C13.9674 4.5022 14.6554 6.15243 14.6549 7.9076C14.6533 11.529 11.683 14.4757 8.0335 14.4757H8.03088C6.84256 14.475 5.67712 14.1584 4.66075 13.56L4.41888 13.4177L1.91275 14.0696L2.58194 11.646Z",
    fill: "url(#paint1_linear_981_1913)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04223 4.59782C5.8931 4.26895 5.73616 4.26232 5.59435 4.25655C5.47823 4.25159 5.34548 4.25196 5.21285 4.25196C5.0801 4.25196 4.86441 4.30151 4.6821 4.49903C4.4996 4.69673 3.98535 5.1745 3.98535 6.14622C3.98535 7.11794 4.69866 8.05711 4.7981 8.18901C4.89766 8.32067 6.17516 10.3786 8.19841 11.1703C9.87991 11.8282 10.2221 11.6974 10.587 11.6644C10.952 11.6315 11.7648 11.1867 11.9306 10.7255C12.0965 10.2644 12.0965 9.86908 12.0468 9.78647C11.997 9.70418 11.8643 9.65475 11.6652 9.55602C11.4662 9.45729 10.4875 8.9794 10.305 8.91348C10.1225 8.84762 9.98985 8.81475 9.8571 9.01252C9.72435 9.20998 9.34316 9.65475 9.22698 9.78647C9.11091 9.9185 8.99473 9.93494 8.79573 9.83615C8.59654 9.73704 7.95548 9.52873 7.19491 8.85593C6.60316 8.33239 6.20366 7.68588 6.08754 7.48811C5.97141 7.29066 6.0751 7.18362 6.17491 7.0852C6.26435 6.9967 6.37404 6.85456 6.47366 6.73928C6.57291 6.62393 6.60604 6.54163 6.67241 6.40991C6.73885 6.27807 6.7056 6.16272 6.65591 6.06393C6.60604 5.96514 6.21923 4.98833 6.04223 4.59782Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_981_1913",
    x1: 772.568,
    y1: 1539.78,
    x2: 772.568,
    y2: 0.275391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_981_1913",
    x1: 800,
    y1: 1594.71,
    x2: 800,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_981_1913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.1dd38e1eae9ab1c934e8b953e07bd854.svg";
export { ForwardRef as ReactComponent };